import { isFieldRestricted } from 'customer-data-filters-ui/utils/fieldLevelPermissions';
import { useActiveFields } from './useActiveFields';
import { useCallback } from 'react';
import pipe from 'transmute/pipe';
export const utils = {
  disableRestrictedFields: fields => {
    if (!fields) {
      return fields;
    }
    return fields.map(field => {
      const isRestricted = isFieldRestricted(field.get('accessLevel'));
      if (isRestricted) {
        return field.merge({
          disabled: true
        });
      }
      return field;
    });
  },
  disableGroupedRestrictedFields: groups => {
    if (groups) {
      return groups.map(group => {
        return group.set('properties', utils.disableRestrictedFields(group.properties));
      });
    }
    return undefined;
  }
};
export const useDisableFields = filterFamily => {
  const {
    disableActiveFields,
    disableGroupedActiveFields
  } = useActiveFields(filterFamily);
  const disableFields = useCallback(allFields => {
    const disableFunctions = [disableActiveFields];
    disableFunctions.push(utils.disableRestrictedFields);
    return pipe(...disableFunctions)(allFields);
  }, [disableActiveFields]);
  const disableFieldGroups = useCallback(allFieldGroups => {
    const disableFunctions = [disableGroupedActiveFields];
    disableFunctions.push(utils.disableGroupedRestrictedFields);
    return pipe(...disableFunctions)(allFieldGroups);
  }, [disableGroupedActiveFields]);
  return {
    disableFields,
    disableFieldGroups
  };
};